import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Phone, Mail, MapPin, Truck, ShieldCheck, Frame } from 'lucide-react';
import { useSiteSettings } from '../../context/SiteSettingsContext';
import { legalPageAPI } from '../../services/api';

export default function Footer() {
    const { settings } = useSiteSettings();
    const [legalPages, setLegalPages] = useState([]);

    useEffect(() => {
        legalPageAPI.getAll().then(res => setLegalPages(res.data || [])).catch(() => {});
    }, []);

    return (
        <footer className="footer">
            {/* Trust Bar */}
            <div className="footer-trust-bar">
                <div className="footer-trust-inner">
                    <div className="footer-trust-item">
                        <Truck size={22} />
                        <div>
                            <strong>Ücretsiz Kargo</strong>
                            <span>Tüm siparişlerde</span>
                        </div>
                    </div>
                    <div className="footer-trust-item">
                        <Frame size={22} />
                        <div>
                            <strong>Özenli Paketleme</strong>
                            <span>Hasarsız teslimat</span>
                        </div>
                    </div>
                    <div className="footer-trust-item">
                        <ShieldCheck size={22} />
                        <div>
                            <strong>Güvenli Alışveriş</strong>
                            <span>256-bit SSL şifreleme</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Footer */}
            <div className="footer-main">
                <div className="footer-main-inner">
                    {/* Brand Column */}
                    <div className="footer-brand-col">
                        <img src="/logo.svg" alt="Atölye Kirpi" className="footer-logo" />
                        <p className="footer-tagline">Duvarlarınız için özenle seçilmiş tablo koleksiyonları.</p>
                        <div className="footer-social">
                            {settings.instagram && <a href={settings.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={18} /></a>}
                            {settings.facebook && <a href={settings.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={18} /></a>}
                            {settings.youtube && <a href={settings.youtube} target="_blank" rel="noopener noreferrer" aria-label="Youtube"><Youtube size={18} /></a>}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-col">
                        <h5>Koleksiyon</h5>
                        <Link to="/urunler">Tüm Tablolar</Link>
                        <Link to="/urunler?sort=newest">Yeni Eklenenler</Link>
                        <Link to="/urunler">Kategoriler</Link>
                    </div>

                    {/* Info Links */}
                    <div className="footer-col">
                        <h5>Bilgi</h5>
                        <Link to="/hakkimizda">Hakkımızda</Link>
                        <Link to="/iletisim">İletişim</Link>
                        {legalPages.map(page => (
                            <Link key={page.id} to={`/sayfa/${page.slug}`}>{page.title}</Link>
                        ))}
                    </div>

                    {/* Contact */}
                    <div className="footer-col">
                        <h5>İletişim</h5>
                        {settings.email && (
                            <a href={`mailto:${settings.email}`} className="footer-contact-link">
                                <Mail size={14} />
                                <span>{settings.email}</span>
                            </a>
                        )}
                        {settings.phone && (
                            <a href={`tel:${settings.phone.replace(/\s/g, '')}`} className="footer-contact-link">
                                <Phone size={14} />
                                <span>{settings.phone}</span>
                            </a>
                        )}
                        {settings.address && (
                            <div className="footer-contact-link">
                                <MapPin size={14} />
                                <span>{settings.address}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Payment */}
            <div className="footer-payment">
                <img src="/iyzico-footer-band.svg" alt="iyzico ile güvenli ödeme" className="footer-payment-band" />
            </div>

            {/* Bottom */}
            <div className="footer-bottom">
                <span>&copy; {new Date().getFullYear()} Atölye Kirpi</span>
                <span className="footer-sep">·</span>
                <a href="https://megedigital.com" target="_blank" rel="noopener noreferrer">megedigital.com</a>
            </div>
        </footer>
    );
}
